import { VaunceAppV2AppTicketType } from '@kinderlabs-pos/shared-data-type';
import { getDateTimeFormat } from '@kinderlabs-pos/shared-util';
import { VaunceAppTicketQueryState } from '@kinderlabs-pos/state';
import { WithDialog, XlDialogProps } from '@kinderlabs-pos/ui-atoms';
import { DialogContent, Divider, List, ListItem, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Fragment } from 'react';

interface VaunceAppTicketHistoryDialogProps extends XlDialogProps {
	ticketId: number;
	ticketType: VaunceAppV2AppTicketType;
}
export const VaunceAppTicketHistoryDialog = ({
	open,
	closeDialog,
	ticketId,
	ticketType,
}: VaunceAppTicketHistoryDialogProps) => {
	const { data } = useQuery({
		...VaunceAppTicketQueryState.keys.history(`${ticketId}`, ticketType),
	});

	const histories = data ?? [];

	return (
		<WithDialog.XlDialog
			dialogTitle={`티켓 #${ticketId} 사용내역 조회`}
			open={open}
			closeDialogAction={'닫기'}
			closeDialog={closeDialog}>
			<DialogContent sx={{ minWidth: 428 }}>
				{histories.length === 0 ? (
					<Stack
						height={'100%'}
						justifyContent={'cneter'}
						alignItems={'center'}>
						<Typography
							variant='subtitle1'
							color={'text.secondary'}>
							{'사용 내역 없음'}
						</Typography>
					</Stack>
				) : (
					<List>
						{histories.map((posHistory, idx) => (
							<Fragment key={idx}>
								<ListItem>
									<Stack
										direction={'row'}
										spacing={4}>
										<Stack flex={1}>
											<Typography variant={'subtitle1'}>{`#${posHistory.ticketId}`}</Typography>
										</Stack>
										<Stack>
											{posHistory.historyType === 'USED' && (
												<Typography
													variant='subtitle2'
													color={'primary'}>
													사용 처리
												</Typography>
											)}
											{posHistory.historyType === 'USE_CANCELED' && (
												<Typography
													variant='subtitle2'
													color={'error'}>
													취소 처리
												</Typography>
											)}
											<Typography
												variant={'body1'}
												color={'text.secondary'}>
												{getDateTimeFormat(posHistory.createdDate)}
											</Typography>
										</Stack>
									</Stack>
								</ListItem>
								<Divider />
							</Fragment>
						))}
					</List>
				)}
			</DialogContent>
		</WithDialog.XlDialog>
	);
};
